/* ═══════════════════════════════════════════════
   FRXN Landing Page — Behavior
   - Reveal animations on scroll (IntersectionObserver)
   - Email capture form interception (no-op until wired)
   ═══════════════════════════════════════════════ */

(function () {
  'use strict';

  function initRevealAnimations() {
    if (!('IntersectionObserver' in window)) {
      // Fallback for old browsers — just show everything
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('in');
      });
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    document.querySelectorAll('.reveal').forEach(function (el) {
      obs.observe(el);
    });
  }

  /*
    Email capture forms — wire to your provider here.
    Both forms have a data-email-capture attribute identifying the source:
    - data-email-capture="soft-offer"  (mid-page conversion form)
    - data-email-capture="footer"      (footer subscribe form)

    Replace the body of this function with your provider's signup logic
    (Klaviyo, Mailchimp, Shopify Email, ConvertKit, etc.).
  */
  function initEmailCapture() {
    var forms = document.querySelectorAll('form[data-email-capture]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var emailInput = form.querySelector('input[type="email"]');
        if (!emailInput) return;
        var email = emailInput.value;
        var source = form.getAttribute('data-email-capture');

        // TODO: Replace with real provider integration.
        // Example shape for Klaviyo / Mailchimp / etc.:
        //
        //   fetch('YOUR_ENDPOINT', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({ email: email, source: source })
        //   })
        //   .then(function (r) { return r.json(); })
        //   .then(function () { showSuccess(form); })
        //   .catch(function () { showError(form); });

        console.log('[FRXN email capture]', { source: source, email: email });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRevealAnimations();
      initEmailCapture();
    });
  } else {
    initRevealAnimations();
    initEmailCapture();
  }
})();
